import parseIsdoc from "./parseIsdoc";
import parseUbl from "./parseUbl";
import { XmlFormat, XmlInvoice } from "./types";

const PARSERS: Record<XmlFormat, (doc: Document) => XmlInvoice> = {
    isdoc: parseIsdoc,
    ubl: parseUbl,
};

export default function parseInvoice(doc: Document, format: XmlFormat): XmlInvoice {
    return PARSERS[format](doc);
}
